// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5290":"db3d3fb04521abff","6853":"5d7597e615e1f02a","8319":"071354dcd0758786"}[chunkId] + ".js";
};